import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, map, mergeMap, of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { SnackbarService } from '@shared';
import {
  getRegistrationDataFailure,
  getRegistrationDataSuccess,
  RegistrationDataActionTypes,
  updateRegistrationDataFailure,
  updateRegistrationDataSuccess,
} from '../actions';

import { RegistrationDataService } from '../../services';
import { IRegistrationData } from '@shared/model/basic-data';
import { ErrorsService } from '@app/errors/errors.service';

@Injectable()
export class RegistrationDataEffects {
  constructor(
    private _actions$: Actions,
    private _registrationDataService: RegistrationDataService,
    private _snackbarService: SnackbarService,
    private _errorsService: ErrorsService,
  ) {}

  getRegistrationData$ = createEffect(() =>
    this._actions$.pipe(
      ofType(RegistrationDataActionTypes.GET_REGISTRATION_DATA),
      mergeMap(({ id }) =>
        this._registrationDataService.getRegistrationData(id).pipe(
          map((registrationData: IRegistrationData) => getRegistrationDataSuccess({ registrationData })),
          catchError((err: HttpErrorResponse) => {
            if (err.error.detail) {
              this._errorsService.openPopup(err);
            } else {
              this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            }
            return of(getRegistrationDataFailure());
          }),
        ),
      ),
    ),
  );

  updateRegistrationData$ = createEffect(() =>
    this._actions$.pipe(
      ofType(RegistrationDataActionTypes.UPDATE_REGISTRATION_DATA),
      mergeMap(({ id, data }) =>
        this._registrationDataService.updateRegistrationData(id, data).pipe(
          map(() => updateRegistrationDataSuccess({ data })),
          catchError(() => of(updateRegistrationDataFailure())),
        ),
      ),
    ),
  );
}
